import CurrentDate from "./CurrentDate";
import ConvertCurrentTemperature from "./ConvertCurrentTemperature";

import "./CurrentWeather.css";

export default function CurrentWeather(props) {
  return (
    <div className="weather-container">
      <div>
        <h1 className="current-city">{props.weather.city}</h1>
      </div>
      <div className="weather-data">
        <p className="current-details">
          <CurrentDate
            date={props.weather.time}
            timezone={props.weather.timezone}
          />
          ,<span className="description"> {props.weather.description}</span>
          <br />
          Humidity:{" "}
          <strong className="humidity">{props.weather.humidity}%</strong>, Wind
          :{" "}
          <strong className="wind">{Math.round(props.weather.wind)}km/h</strong>
        </p>

        <div className="current-weather">
          <span className="current-weather-icon">
            <img src={props.weather.icon} alt="weather icon" />
          </span>
          <ConvertCurrentTemperature
            temperature={props.weather.temperature}
            unit={props.unit}
            setUnit={props.setUnit}
          />
        </div>
      </div>
    </div>
  );
}
